export default function IndexSection() {
  const items = [
    { name: '明星恋情', icon: 'ri-heart-line', count: '236条', color: 'accent' },
    { name: '综艺内幕', icon: 'ri-tv-line', count: '189条', color: 'primary' },
    { name: '网红翻车', icon: 'ri-emotion-sad-line', count: '312条', color: 'accent' },
    { name: '影视争议', icon: 'ri-film-line', count: '167条', color: 'primary' },
    { name: '品牌风波', icon: 'ri-shopping-bag-line', count: '145条', color: 'secondary' },
    { name: '直播乱象', icon: 'ri-live-line', count: '203条', color: 'accent' },
    { name: '音乐圈瓜', icon: 'ri-music-line', count: '98条', color: 'primary' },
    { name: '体育八卦', icon: 'ri-football-line', count: '134条', color: 'secondary' },
    { name: '海外爆料', icon: 'ri-global-line', count: '87条', color: 'primary' },
  ];

  const colorMap: Record<string, string> = {
    accent: 'bg-accent-100/20 text-accent-400',
    primary: 'bg-primary-100/20 text-primary-400',
    secondary: 'bg-secondary-100/20 text-secondary-400',
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-400 bg-primary-100/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            <i className="ri-folder-line"></i>
            Content Index
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            专题索引
          </h2>
          <p className="text-sm text-foreground-500">按分类浏览你最感兴趣的黑料内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((item) => (
            <a
              key={item.name}
              href="#topics"
              className="flex items-center gap-4 bg-background-100 border border-background-200/60 rounded-lg p-4 hover:border-background-300/60 transition-all group cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${colorMap[item.color]}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm font-bold text-foreground-200 group-hover:text-primary-400 transition-colors">
                  {item.name}
                </h3>
                <p className="text-xs text-foreground-600 mt-0.5">已收录 {item.count}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-600 group-hover:text-foreground-400 transition-colors"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}